import { createAction, createSlice } from "@reduxjs/toolkit";
import { Notification, NotificationManageQueryParams } from "../type";
import {
	COMMON_STATUS,
	languages,
	NOTIFICATION_ROUTER_SETTING,
	notificationSettingTypes,
} from "constants/constants";
import { RootState } from "store/store";

export const initialNotification = {
	id: 0,
	status: "Unsent",
	schedule: "",
	userGroupType: "customer",
	sentTime: "",
	settingType: notificationSettingTypes[1]?.value,
	routerSetting: {
		type: NOTIFICATION_ROUTER_SETTING.EXTERNAL_LINK,
		screenKey: "",
		parameter: "",
		link: "",
	},
	translations: languages.map(val => ({
		image: "",
		title: "",
		body: "",
		bodyHtml: "",
		language: val.key,
	})),
	users: [],
};

export const initialAddMemberQuery = {
	skip: 0,
	take: 10,
	isRemoved: false,
	status: COMMON_STATUS.enable.value,
	fullName: null,
	phoneNumber: null,
	email: null,
};

export interface NotificationState {
	notificationList: Notification[];
	notificationDetail: Notification;
	notificationManageTotal: number;
}

const initialState: NotificationState = {
	notificationList: [],
	notificationDetail: initialNotification,
	notificationManageTotal: 0,
};

export const notificationManageSlice = createSlice({
	name: "notificationManage",
	initialState,
	reducers: {
		setListNotification: (state, action) => {
			state.notificationList = action.payload.data;
			state.notificationManageTotal = action.payload.total;
		},
		setDetailNotification: (state, action) => {
			state.notificationDetail = action.payload.data;
		},
	},
});

export const { setListNotification, setDetailNotification } =
	notificationManageSlice.actions;

export const selectNotificationList = (state: RootState) =>
	state.notificationManage.notificationList;
export const selectNotificationDetail = (state: RootState) =>
	state.notificationManage.notificationDetail;
export const selectNotificationManageTotal = (state: RootState) =>
	state.notificationManage.notificationManageTotal;

export interface GetListNotificationPayload {
	query: NotificationManageQueryParams;
	callback: () => void;
}

export const getListNotificationAsync = createAction(
	"notificationManage/getListNotificationAsync",
	payload => ({
		payload,
	}),
);

export interface GetDetailNotificationPayload {
	id: string;
	callback: () => void;
}

export const getDetailNotificationAsync = createAction(
	"notificationManage/getDetailNotificationAsync",
	payload => ({
		payload,
	}),
);

export interface CreateNotificationPayload {
	data: Notification;
	callback: () => void;
}

export const createNotificationAsync = createAction(
	"notificationManage/createNotificationAsync",
	payload => ({
		payload,
	}),
);

export interface UpdateNotificationPayload {
	id: string;
	callback: () => void;
	data: Notification;
}

export const updateNotificationAsync = createAction(
	"notificationManage/updateNotificationAsync",
	payload => ({
		payload,
	}),
);

export interface DeleteNotificationPayload {
	id: string;
	callback: () => void;
	query: NotificationManageQueryParams;
}

export const deleteNotificationAsync = createAction(
	"notificationManage/deleteNotificationAsync",
	payload => ({
		payload,
	}),
);

export default notificationManageSlice.reducer;
